export enum AuthRoutes {
  blank = '/',
  dashboard = '/dashboard',
  users = '/users',
  vendors = '/vendors',
  customers = '/customers',
  profile = '/profile',
  changePassword = '/change-password',
  properties = '/properties',
}

export enum RouteParamsTypes {
  any = '/*',
  id = '/:id',
  blank = '',
  add = '/add',
  edit = '/edit',
  view = '/view',
  list = '/list',
  payout = '/payout',
  managerStatement = '/manager-statement',
}

export enum Modules {
  auth = '/auth',
  home = '/home',
  resources = '/resources',
  transactions = '/transactions',
  reservations = '/reservations',
  propertyVisits = '/property-visits',
  invoices = '/invoices',
  reconciliation = '/reconciliation',
  auditLogs = '/audit-logs',
  error = '/error',
  my = '/my'
}

export enum NonAuthRoutes {
  login = '/login',
  forbidden = '/forbidden',
  unHandledRejection = '/server-error',
  notFound = '/page-not-found',
  forgotPassword = '/forgot-password',
  resetPassword = '/reset-password'
}

export enum PermissionActionsEnum {
  View = "view",
  Add = "add",
  Update = "update",
  Delete = "delete",
  Email = "email",
  Export = "export",
  Import = "import",
  Complete = "complete",
  Verify = "invoice_verification",
  Active = "active",
  PayoutVerification = "payout_verification",
  Chargeable = "chargeable"
}

export enum PermissionModulesEnum {
  Users = 'users',
  Dashboard = 'dashboard',
  Property = 'property',
  Customers = 'customer',
  Vendor = 'vendor',
  Transaction = 'transaction',
  Expense = 'expense',
  Reservation = 'reservation',
  Invoices = 'invoice',
  Payments = 'payment',
  ClientStatement = 'client_statement',
  Reconciliation = 'reconciliation_payout',
  PropertyVisit = 'property_visit',
  ManagerStatement = 'manager_statement',
  // Not a seeded functionality: only the system administrator passes (see RBAC.md §7)
  AuditLog = 'audit_log'
}

export enum SortOrder {
  asc = 'ASC',
  desc = 'DESC'
}

export enum RowClassName {
  even = 'even',
  odd = 'odd'
}

export enum RoleCodes {
  system_admin = 'system_admin',
  admin = 'admin',
  manager = 'manager',
  inspector = 'inspector',
}
